/** Shared landing surface styles — glass cards, section shell, CTAs. */

export const landingPrimaryCtaClass =
  'inline-flex h-12 w-full items-center justify-center rounded-xl bg-primary px-6 text-base font-semibold text-primary-foreground shadow-lg shadow-primary/25 transition-all hover:bg-primary/90 hover:shadow-primary/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring sm:w-auto'

export const landingHeaderCtaClass =
  'inline-flex h-10 items-center justify-center rounded-xl bg-primary px-5 text-sm font-semibold text-primary-foreground shadow-md shadow-primary/20 transition-all hover:bg-primary/90 sm:h-11 sm:px-6 sm:text-base'

export const landingSecondaryCtaClass =
  'inline-flex h-12 w-full items-center justify-center rounded-xl border border-slate-200/80 bg-white/70 px-6 text-base font-semibold text-foreground shadow-sm transition-all hover:bg-white hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring sm:w-auto'

export const landingSurfaceClass =
  'rounded-[1.75rem] border border-white/70 bg-white/55 shadow-[0_24px_80px_-24px_rgba(15,23,42,0.14)] ring-1 ring-slate-900/[0.04] backdrop-blur-xl'

export const landingCapabilityCardClass =
  'flex h-full flex-col rounded-xl border border-white/80 bg-white/80 p-4 shadow-sm ring-1 ring-slate-900/[0.03] backdrop-blur-sm transition duration-200 hover:-translate-y-0.5 hover:shadow-md sm:p-5'

export const landingCompactCardClass =
  'flex h-full flex-col rounded-xl border border-white/80 bg-white/80 p-3.5 shadow-sm ring-1 ring-slate-900/[0.03] backdrop-blur-sm transition duration-200 hover:-translate-y-0.5 hover:shadow-md sm:p-4'

export const landingDemoShellClass =
  'overflow-hidden rounded-[1.5rem] border border-white/80 bg-white/80 shadow-[0_24px_64px_-20px_rgba(15,23,42,0.16)] ring-1 ring-slate-900/[0.05] backdrop-blur-md'
